<template>
  <div class="page-content-mobile">
    <!-- 头部banner -->
    <div class="banner">
      <div class="introduce">
        <div class="introduce-title">
          智寰科技
        </div>
        <div class="introduce-desc">
          <div>重新定义客户服务</div>
          <div>AI驱动，体验升级</div>
        </div>
      </div>
    </div>

    <!-- 公司介绍板块 -->
    <div class="company-section">
      <div class="company-introduction">
        <div class="company-content">
          <div class="about-title">{{ companyIntroData.title }}</div>
          <div class="about-desc">
            <div v-for="(line, i) in companyIntroData.desc" :key="i">{{ line }}</div>
          </div>
          <div class="company-video">
            <div class="video-container" @click="playCompanyVideo">
              <video v-if="companyVideoPlaying" :src="companyMp4" controls autoplay
                class="company-video-player"></video>
              <img v-else :src="companyCover" alt="公司视频封面" class="video-cover" />
              <div v-if="!companyVideoPlaying" class="play-button">
                <div class="play-icon">▶</div>
              </div>
            </div>
          </div>
          <div class="about-statistics">
            <div class="about-statistics-row" v-for="(row, rowIdx) in companyIntroData.statistics" :key="rowIdx">
              <div class="about-statistics-item" v-for="item in row" :key="item.label">
                <div class="about-statistics-value">{{ item.value }}</div>
                <div class="about-statistics-label">{{ item.label }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- 智寰企业文化板块 -->
    <div class="culture-section">
      <div class="title-box">
        <div class="title-text">
          智寰企业文化
        </div>
      </div>
      <div class="statistics-section">
        <div class="statistics-grid">
          <div class="statistics-item" v-for="(item) in statisticsList" :key="item.title">
            <img :src="item.icon" :alt="item.title" class="statistics-icon" />
            <div class="statistics-info">
              <div class="statistics-value">
                <span>{{ item.value1 }}</span>
                <span class="english-value">{{ item.value2 }}</span>
              </div>
              <div class="statistics-title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="culture-bg">
        <img :src="cultureBgTop" alt="企业文化背景" class="culture-bg-img" />
      </div>
    </div>

    <!-- 团队实力板块 -->
    <div class="team-section">
      <div class="title-box">
        <div class="title-text">
          智寰团队实力
        </div>
      </div>
      <div class="team-strength">
        <div class="team-timeline">
          <div class="team-item" v-for="item in teamStrengthList" :key="item.title">
            <div class="team-content">
              <div class="team-title">{{ item.title }}</div>
              <div class="team-desc">
                <div v-for="(desc, i) in item.desc" :key="i">{{ desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 公司环境板块 -->
    <div class="environment-section">
      <div class="title-box">
        <div class="title-text">
          {{ environmentData.title }}
          <!-- <span class="title-highlight">{{ environmentData.subtitle }}</span> -->
        </div>
      </div>
      <div class="environment-content">
        <div class="environment-img">
          <img :src="environmentImg" alt="公司环境" class="environment-image" />
        </div>
        <div class="environment-info">
          <div class="environment-stats">
            <div class="environment-stat" v-for="item in environmentData.stats" :key="item.label">
              <div class="environment-stat-value">{{ item.value }}<span v-if="item.unit">{{ item.unit }}</span></div>
              <div class="environment-stat-label">{{ item.label }}</div>
            </div>
          </div>
          <div>
            <div class="environment-desc-title">
              <span class="title-highlight">卓越</span>
              <span>的办公环境</span>
            </div>
          </div>
          <div class="environment-desc">{{ environmentData.desc }}</div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import companyCover from '../../assets/img/about/pc/company_cover.png'
import companyMp4 from '../../assets/video/company.mp4'

import cultureicon1 from '../../assets/img/about/pc/culture_icon1.png'
import cultureicon2 from '../../assets/img/about/pc/culture_icon2.png'
import cultureicon3 from '../../assets/img/about/pc/culture_icon3.png'
import cultureicon4 from '../../assets/img/about/pc/culture_icon4.png'
import cultureBgTop from '../../assets/img/about/mobile/culture_bg_top.png'

import environmentImg from '../../assets/img/about/mobile/environment_img.png'

export default {
  name: 'AboutMobile',
  data() {
    return {
      // 智寰企业文化数据
      cultureicon1,
      cultureicon2,
      cultureicon3,
      cultureicon4,
      cultureBgTop,

      statisticsList: [
        { title: '成为世界领先的智能交互技术产品与服务提供商', value1: '定位', value2: 'POSITION', icon: cultureicon1 },
        { title: '智寰科技让电商人营销更简单', value1: '使命', value2: 'MISSION', icon: cultureicon2 },
        { title: '持续创新、技术突破、商业落地', value1: '经营理念', value2: 'CONCEPT', icon: cultureicon3 },
        { title: '成为数智化服务的引领者', value1: '愿景', value2: 'VISION', icon: cultureicon4 }
      ],

      // 公司介绍板块数据
      companyVideoPlaying: false,
      companyCover,
      companyMp4,
      companyIntroData: {
        title: '关于智寰科技',
        desc: [
          '专注人工智能（AI）核心技术（计算机视觉、深度学习、图形学）研发与应用，致力于助力企业智能化升级。公司为各行业量身打造智能化解决方案，通过实现自动化管理与智能决策，有效提升效率、降低成本，达成降本增效目标。',
          '依托央视权威背书及国家级媒体资源，公司成功构建公众信任，实现从技术领先到市场认可的跨越式发展。未来将持续以“持续创新+技术突破+商业落地”三轮驱动战略，打造多领域AI生态系统，为行业智能化转型提供核心支撑。'
        ],
        statistics: [
          [
            { value: '45600+', label: '连接设备' },
            { value: '3500+', label: '注册用户' },
            { value: '268万+', label: '日上传数据量' }
          ],
          [
            { value: '60%', label: '释放人力' },
            { value: '98.5%', label: '客户满意度' },
            { value: '95.14%', label: '问题处理率' }
          ]
        ]
      },

      // 团队实力板块数据
      teamStrengthList: [
        {
          class: 'team-strength-topleft',
          title: '技术总监',
          desc: [
            '北京大学计算机科学与技术博士，具备算法工程化能力和商业敏感度，深耕人工智能领域20年，曾担任阿里云事业部技术总监，精通Transformer/GNN/DDPM等架构创新，服务超200家政府与企业客户。持有3项AI模型优化相关发明专利，主导过千万级用户的智能客服系统升级,在人工智能科学顶级学术会议上以第一作者累计发表论文20余篇。'
          ]
        },
        {
          class: 'team-strength-topright',
          title: 'AI产品经理',
          desc: [
            '武汉大学电子信息/自动化+心理学双学位，擅长用户画像与场景拆解，熟悉ISO/IEC 23053,对自然语言处理（NLP）、情感计算、人机交互有独特视角。曾任职大厂，领导10人跨职能团队，主导过用户量级超千万的智能产品，相关论文曾被ACL 2024收录。'
          ]
        },
        {
          class: 'team-strength-bottomleft',
          title: '算法工程师',
          desc: [
            '武汉工程大学计算机科学与技研究生，精通Transformer/GNN/强化学习框架创新，熟悉Docker/K8s部署,精通CUDA优化,8年大厂核心模型研发经验,主导过3个千万级用户规模的AI模型迭代, CCF人工智能会议青年论坛演讲嘉宾。'
          ]
        },
        {
          class: 'team-strength-bottomright',
          title: 'AI 训练工程师',
          desc: [
            '毕业于武汉大学，深耕机器学习、深度学习等核心课程，精通 PyTorch、TensorFlow 等主流框架，擅长分布式训练策略设计与硬件加速优化',
            '主导过 10 余个大型 AI 模型训练项目，涵盖自然语言处理、计算机视觉等多模态领域。'
          ]
        }
      ],

      // 公司环境板块数据
      environmentData: {
        title: '公司环境',
        desc: '公司坐落于武汉汉口核心区域，毗邻西北湖金融商务区，地处建设大道与青年路交汇处，坐拥城市黄金中轴线。周边5公里范围内覆盖武汉CBD、武广商圈等顶级资源带。',
        stats: [
          { value: '1500', unit: '²', label: '办公室面积' },
          { value: '450+', label: '公司员工' },
          { value: '30+', label: '业务覆盖城市' }
        ]
      },
      environmentImg,
    }
  },
  methods: {
    playCompanyVideo() {
      this.companyVideoPlaying = true;
    },
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/mobile-responsive.scss' as mobile;

.page-content-mobile {
  @include mobile.mobile-page-content;
  background-color: #F5F7FB;

  // 头部banner
  .banner {
    height: mobile.px2rem(180);
    display: flex;
    background: url('../../assets/img/about/mobile/banner.png') no-repeat center center;
    background-size: cover;
    text-align: center;

    .introduce {
      padding-left: mobile.px2rem(28);
      margin-top: mobile.px2rem(40);

      .introduce-title {
        font-size: mobile.px2rem(24);
        line-height: mobile.px2rem(24);
        font-weight: 800;
        color: #2B3167;
        text-align: left;
      }

      .introduce-desc {
        font-weight: 500;
        font-size: mobile.px2rem(16);
        color: #2B3167;
        margin-top: mobile.px2rem(20);
        line-height: px2rem(20);
      }
    }
  }

  // 通用标题样式
  .title-box {
    text-align: center;

    .title-text {
      font-size: mobile.px2rem(20);
      font-weight: 800;
      color: #333333;
    }
  }

  // 公司介绍板块
  .company-section {
    padding: mobile.px2rem(28) mobile.px2rem(15) mobile.px2rem(22);
    background: #fff;
    margin-bottom: mobile.px2rem(36);

    .company-introduction {
      .company-content {
        .about-title {
          font-size: mobile.px2rem(20);
          font-weight: 800;
          color: #333333;
          margin-bottom: mobile.px2rem(8);
        }

        .about-desc {
          font-weight: 500;
          font-size: mobile.px2rem(12);
          color: #6F6F6F;
          text-align: left;
          text-indent: 1em;
          margin-bottom: mobile.px2rem(16);
        }

        .company-video {
          margin-bottom: mobile.px2rem(16);

          .video-container {
            position: relative;
            width: 100%;
            height: mobile.px2rem(193);
            border-radius: 4px;
            overflow: hidden;
            cursor: pointer;

            .company-video-player,
            .video-cover {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .play-button {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: mobile.px2rem(44);
              height: mobile.px2rem(44);
              background: rgba(255, 255, 255, 0.8);
              border: 1px solid #FFFFFF;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;

              .play-icon {
                color: #0051ff;
                font-size: mobile.px2rem(16);
                margin-left: mobile.px2rem(4);
              }
            }
          }
        }

        .about-statistics {
          .about-statistics-row {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            margin-bottom: mobile.px2rem(37);

            &:last-child {
              margin-bottom: 0;
            }

            .about-statistics-item {
              text-align: center;
              border-radius: mobile.px2rem(8);

              .about-statistics-value {
                font-size: mobile.px2rem(20);
                line-height: mobile.px2rem(20);
                font-weight: 800;
                color: #333333;
                margin-bottom: mobile.px2rem(9);
              }

              .about-statistics-label {
                font-weight: 800;
                font-size: mobile.px2rem(14);
                color: #666;
              }
            }
          }
        }
      }


    }
  }

  // 智寰企业文化板块
  .culture-section {
    // padding: mobile.px2rem(24) mobile.px2rem(20);
    margin-bottom: mobile.px2rem(28);

    .statistics-section {
      margin-top: mobile.px2rem(24);
      margin-bottom: mobile.px2rem(16);
      padding: 0 mobile.px2rem(15);

      .statistics-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: mobile.px2rem(12);

        .statistics-item {
          display: flex;
          align-items: center;
          text-align: left;
          padding: mobile.px2rem(10) mobile.px2rem(0) mobile.px2rem(10) mobile.px2rem(9);
          background: #fff;
          box-shadow: 0px 2px 8px 1px rgba(127, 139, 163, 0.12);
          border-radius: 4px;
          gap: mobile.px2rem(12);

          .statistics-icon {
            width: mobile.px2rem(60);
            height: mobile.px2rem(60);
          }

          .statistics-info {
            .statistics-value {
              font-size: mobile.px2rem(20);
              font-weight: 800;
              color: #0051FF;
              margin-bottom: mobile.px2rem(8);

              .english-value {
                font-size: mobile.px2rem(16);
                font-weight: 500;
                margin-left: mobile.px2rem(6);
                // vertical-align: bottom;
              }
            }

            .statistics-title {
              font-weight: 500;
              font-size: mobile.px2rem(12);
              // color: #0051FF;
              color: #333;
            }
          }
        }
      }
    }

    .culture-bg {
      text-align: center;

      .culture-bg-img {
        width: 100%;
        height: mobile.px2rem(177);
      }
    }
  }

  // 团队实力板块
  .team-section {

    .team-strength {
      margin-top: mobile.px2rem(24);

      .team-timeline {
        position: relative;
        margin-left: mobile.px2rem(30);
        margin-right: mobile.px2rem(15);
        padding-left: mobile.px2rem(15);

        .team-item {
          position: relative;
          margin-bottom: mobile.px2rem(16);


          &:last-child {
            margin-bottom: 0;

            &::after {
              display: none;
            }
          }

          // 圆点
          &::before {
            content: '';
            position: absolute;
            left: mobile.px2rem(-28);
            top: mobile.px2rem(16);
            width: mobile.px2rem(8);
            height: mobile.px2rem(8);
            background: #fff;
            border: mobile.px2rem(3) solid #fff;
            border-radius: 50%;
            box-shadow: 0 0 0 mobile.px2rem(5) #0051FF;
            z-index: 10;
          }

          // 连接线
          &::after {
            content: '';
            position: absolute;
            left: mobile.px2rem(-24);
            top: mobile.px2rem(28);
            width: mobile.px2rem(1);
            height: calc(100% + mobile.px2rem(8));
            background: #0051FF;
            z-index: 9;
          }

          .team-content {
            background: #fff;
            padding: mobile.px2rem(12);
            border-radius: 4px;

            .team-title {
              font-size: mobile.px2rem(14);
              font-weight: 800;
              color: #333333;
              margin-bottom: mobile.px2rem(4);
              text-align: left;
            }

            .team-desc {
              font-weight: 500;
              font-size: mobile.px2rem(12);
              color: #6F6F6F;
              text-align: left;
              word-break: break-all;
            }
          }
        }
      }
    }
  }

  // 公司环境板块
  .environment-section {
    // padding: mobile.px2rem(24) mobile.px2rem(20);
    // background: #fff;
    // margin-bottom: mobile.px2rem(24);
    margin-top: mobile.px2rem(24);

    .environment-content {
      margin-top: mobile.px2rem(36);
      padding: 0 mobile.px2rem(17);

      .environment-img {
        text-align: center;
        margin-bottom: mobile.px2rem(16);

        .environment-image {
          width: mobile.px2rem(340);
          height: mobile.px2rem(222);
        }
      }

      .environment-info {

        .environment-stats {
          margin-bottom: mobile.px2rem(32);
          display: flex;
          justify-content: space-between;

          .environment-stat {
            text-align: center;

            .environment-stat-value {
              font-size: mobile.px2rem(24);
              font-weight: 800;
              color: #333;
              margin-bottom: mobile.px2rem(4);
            }

            .environment-stat-label {
              font-weight: 800;
              font-size: mobile.px2rem(12);
              color: #333;
            }
          }
        }

        .environment-desc-title {
          font-weight: 800;
          font-size: mobile.px2rem(20);
          text-align: left;
          margin-bottom: mobile.px2rem(18);

          .title-highlight {
            color: #0051FF;
          }
        }

        .environment-desc {
          font-weight: 500;
          font-size: mobile.px2rem(14);
          color: #606060;
          text-align: left;
          margin-bottom: mobile.px2rem(54);
        }
      }
    }
  }
}
</style>
